// Isi panduan lapor & bayar SPT Tahunan Orang Pribadi di Coretax (bahasa sederhana).
// `need` = modul pajak yang membuat langkah/lampiran ini perlu diisi (kosong = semua orang).
export const STEPS = [
  {
    id: "siap", title: "Siapkan data di web ini dulu",
    simple: "Sebelum buka Coretax, pastikan catatan Anda di sini sudah lengkap. Coretax hanya tempat menyalin angka.",
    points: [
      "Semua pemasukan & pengeluaran tahun ini sudah dicatat.",
      "Daftar Harta (motor, tabungan, tanah, dll.) & Daftar Utang sudah diisi per akhir tahun.",
      "Daftar Tanggungan (istri/anak) sudah diisi bila ada.",
      "Buka Asisten SPT Coretax: semua angka yang akan disalin sudah ada di sana.",
    ],
    links: [["/pribadi/harta", "Daftar Harta"], ["/pribadi/utang", "Daftar Utang"], ["/pribadi/tanggungan", "Daftar Tanggungan"], ["/pribadi/spt-coretax", "Asisten SPT Coretax"]],
  },
  {
    id: "login", title: "Masuk ke Coretax",
    simple: "Buka situs resmi pajak lalu login dengan NIK/NPWP Anda.",
    points: [
      "Buka coretaxdjp.pajak.go.id (pastikan alamatnya benar).",
      "Isi NIK (16 digit) atau NPWP, kata sandi, dan kode keamanan.",
      "Lupa kata sandi? Klik \"Lupa Kata Sandi\" — tautan dikirim ke email/nomor HP yang terdaftar.",
    ],
  },
  {
    id: "otorisasi", title: "Pastikan punya Kode Otorisasi (tanda tangan digital)",
    simple: "Ini seperti PIN untuk menandatangani SPT. Cukup dibuat sekali.",
    points: [
      "Menu Portal Saya → Permintaan Kode Otorisasi/Sertifikat Elektronik.",
      "Pilih Kode Otorisasi DJP, buat passphrase (kata sandi khusus tanda tangan), simpan baik-baik.",
      "Tanpa ini, tombol Bayar dan Lapor tidak bisa diselesaikan.",
    ],
  },
  {
    id: "konsep", title: "Buat Konsep SPT",
    simple: "\"Konsep\" artinya draf. Bisa diisi pelan-pelan dan disimpan.",
    points: [
      "Menu Surat Pemberitahuan (SPT) → Konsep SPT → Buat Konsep SPT.",
      "Pilih PPh Orang Pribadi → SPT Tahunan → Periode Januari–Desember {tahun} → Model SPT Normal.",
      "Klik Buat Konsep SPT, lalu buka konsepnya (ikon pensil).",
      "Tekan Simpan Konsep sesering mungkin agar isian tidak hilang.",
    ],
  },
  {
    id: "induk", title: "Jawab pertanyaan di tab Induk",
    simple: "Pertanyaan ya/tidak di Induk menentukan lampiran (tab) apa saja yang muncul.",
    points: [
      "Punya usaha/pekerjaan bebas (jualan online, jasa desain, dll.)? Jawab Ya.",
      "Metode yang dipakai: pilih Pencatatan bila Anda memakai PPh Final 0,5% UMKM. Pilih Pembukuan hanya bila Anda membuat neraca & laba rugi.",
      "Bila Anda memilih Pembukuan padahal UMKM, akan muncul L-3A (rekonsiliasi) yang sebenarnya tidak perlu — kembali dan ganti ke Pencatatan.",
      "Status PTKP otomatis dari data kependudukan; cek sesuai kondisi (TK/K & jumlah tanggungan).",
    ],
  },
  { id: "l1a", tab: "L-1", title: "Isi L-1 bagian A — Harta", simple: "Daftar barang/aset yang Anda miliki per 31 Desember.", data: "l1a",
    points: ["Klik Tambah, pilih kode harta, isi nama, tahun perolehan, dan harga perolehan.", "Salin angka dari tab L-1 A di Asisten SPT Coretax."] },
  { id: "l1b", tab: "L-1", title: "Isi L-1 bagian B — Utang", simple: "Utang yang masih ada per 31 Desember (KPR, cicilan bank, dll.). Kosongkan bila tidak ada.", data: "l1b",
    points: ["Isi nama pemberi pinjaman, tahun peminjaman, dan sisa utang.", "Salin dari tab L-1 B di Asisten."] },
  { id: "l1c", tab: "L-1", title: "Isi L-1 bagian C — Tanggungan", simple: "Istri/anak/keluarga sedarah yang Anda tanggung (maks 3 orang).",
    points: ["Isi NIK, nama, hubungan keluarga, dan pekerjaan.", "Data sama dengan menu Daftar Tanggungan di web ini."] },
  { id: "l1d", tab: "L-1", need: "pph21", title: "Isi L-1 bagian D & E — Gaji & Bukti Potong", simple: "Untuk gaji/honor dari pemberi kerja (termasuk gaji direktur PT sendiri).", data: "l1d",
    points: ["Bukti potong 1721-A1/BPMP dari kantor biasanya sudah muncul otomatis di Coretax — cocokkan saja.", "Bila belum muncul, tambahkan nomor bukti potong dari tab L-1 E di Asisten."] },
  { id: "l2a", tab: "L-2", need: "umkm", title: "Isi L-2 bagian A — Penghasilan Final", simple: "Penghasilan yang pajaknya sudah \"beres\" di sumbernya (bunga, reksa dana, omzet UMKM).", data: "l2a",
    points: ["Isi jenis penghasilan, penghasilan bruto, dan PPh final yang terutang.", "Omzet UMKM 0,5% biasanya terisi otomatis dari L-3B."] },
  { id: "l2b", tab: "L-2", title: "Isi L-2 bagian B — Bukan Objek Pajak", simple: "Uang yang diterima tapi bukan penghasilan kena pajak, misalnya hibah/pemberian keluarga.", data: "l2b",
    points: ["Isi jenis (mis. hibah/bantuan) dan jumlahnya.", "Uang titipan, pinjaman, atau pengembalian dana bukan penghasilan — tidak perlu dimasukkan."] },
  { id: "l3b", tab: "L-3B", need: "umkm", title: "Isi L-3B bagian A — Omzet Bulanan UMKM", simple: "Rekap omzet usaha per bulan Januari–Desember.", data: "l3b_a",
    points: ["Isi Daftar Tempat Kegiatan Usaha (TKU) bila diminta.", "Isi peredaran bruto tiap bulan & PPh final yang sudah disetor — salin dari tab L-3B A di Asisten.", "Omzet sampai Rp 500 juta setahun tidak kena PPh final."] },
  { id: "l3a", tab: "L-3A", need: "pembukuan", title: "Isi L-3A — Rekonsiliasi Laporan Keuangan", simple: "Hanya untuk yang membuat pembukuan (neraca & laba rugi).", data: "l3a2",
    points: ["Pilih jenis laporan keuangan, isi peredaran usaha, biaya, dan laba neto.", "Salin dari tab L-3A-2 di Asisten."] },
  {
    id: "cek", title: "Kembali ke Induk & cek hasilnya",
    simple: "Coretax menghitung otomatis. Lihat status SPT di bagian akhir Induk.",
    points: [
      "Nihil = tidak ada pajak yang perlu dibayar.",
      "Kurang Bayar = masih ada pajak yang harus disetor dulu.",
      "Lebih Bayar = pajak yang dipotong/dibayar lebih besar dari seharusnya.",
      "Bandingkan dengan perkiraan dari web ini (kotak status di atas halaman ini).",
    ],
  },
  {
    id: "bayar", title: "Bayar (hanya bila Kurang Bayar)",
    simple: "Coretax membuatkan kode billing — semacam nomor tagihan untuk membayar di bank.",
    points: [
      "Klik Bayar dan Lapor → pilih pembayaran → kode billing dibuat.",
      "Bayar kode billing lewat m-banking/ATM/teller (menu Pajak/Penerimaan Negara/MPN) sebelum masa berlakunya habis.",
      "Simpan bukti bayar (NTPN). Lalu kembali ke konsep SPT untuk melapor.",
    ],
  },
  {
    id: "lapor", title: "Kirim SPT (Lapor)",
    simple: "Langkah terakhir: tanda tangan digital lalu kirim.",
    points: [
      "Centang pernyataan kebenaran data, klik Bayar dan Lapor.",
      "Pilih Kode Otorisasi DJP, masukkan passphrase, lalu Konfirmasi Tanda Tangan.",
      "Bukti Penerimaan Elektronik (BPE) muncul di menu Dokumen Saya — unduh & simpan.",
      "Batas lapor SPT Tahunan Orang Pribadi: 31 Maret tahun berikutnya.",
    ],
  },
];
